function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, reactive, ref, watch, computed, nextTick, getCurrentInstance } from "vue";
// import { definePropType } from '@types-vue/props'
import { AdAuthType } from "@pt/api/user/type";
import { validateEmail, getChannelSubmitQuery, authAuthorizeList, authChannelList, reportPermissionOptions, getAuthItem, PlatformType } from "../config";
import { channelList } from "@com/utils/channel";
import { getAdAuthInfo, submitAdAccountAuth } from "@pt/api/user/index";
import { playTurboHostList } from "@/config/host";
import { NODE_ENV } from "@com/config/env";
import LinkCheckbox from "@com/components/link-checkbox/index.vue";
// import { language } from '@/common/storage'
import AutoTips from "@/components/AutoTips/index.vue";
import { isRecharge } from "@pt/store/user/helper";
import rangeTips from "./rangeTips.vue";
import _ from "lodash";
import { getRouteHelperUrlByDomain } from "@com/utils/helper";
import { isCNSuffix } from "@com/utils/url";
var authDefault = {
    traffic_type: "",
    account_name: "",
    email: "",
    api_key: "",
    access_key: "",
    secret_key: "",
    report_key: "",
    key_id: "",
    org_id: "",
    org_core_id: "",
    client_id: "",
    report_permission: 1,
    is_agree: true,
    client_secret: "",
    refresh_token: "",
    type: AdAuthType.Channel,
    platform_name: ""
};
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AutoTips: AutoTips
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var loading = ref(false);
        var authInfoLoading = ref(false);
        var PTUrl = playTurboHostList[NODE_ENV];
        var formRef = ref();
        // 是否开通计费
        var isRechargePlans = computed(function() {
            return isRecharge(store.state.user.info);
        });
        var channelIds = computed(function() {
            return store.state.user.info.channel_ids || [];
        });
        var addAuthAuthorizeList = computed(function() {
            if (isRechargePlans.value) {
                // 月耗账号（充值消耗套餐）授权渠道
                return channelIds.value.length && channelIds.value[0] !== -1 ? authChannelList().filter(function(item) {
                    return channelIds.value.includes(item.value);
                }) : channelList.filter(function(item) {
                    return item.value === 21 || item.value === 5 || item.value === 7;
                });
            }
            return authAuthorizeList();
        });
        var authModel = reactive(_objectSpread({}, authDefault));
        var authSchemaObj = computed(function() {
            return {
                email: {
                    label: root.$t("playTurbo.authAccount.table.column.email"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("playTurbo.authAccount.table.column.email"))
                        },
                        {
                            validator: validateEmail,
                            trigger: "change"
                        }, 
                    ]
                },
                account_name: {
                    label: root.$t("playTurbo.authAccount.table.column.account"),
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips"),
                        maxlength: 34,
                        "show-word-limit": true
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("playTurbo.authAccount.table.column.account"))
                        }, 
                    ]
                },
                report_key: {
                    label: root.$t("Report Key"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Report Key"))
                        }, 
                    ]
                },
                api_key: {
                    label: root.$t("API Key"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("API Key"))
                        }, 
                    ]
                },
                access_key: {
                    label: root.$t("Access Key"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Access Key"))
                        }, 
                    ]
                },
                secret_key: {
                    label: root.$t("Secret Key"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Secret Key"))
                        }, 
                    ]
                },
                refresh_token: {
                    label: root.$t("Refresh Token"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Refresh Token"))
                        }, 
                    ]
                },
                client_id: {
                    label: authModel.traffic_type === PlatformType.Xmp ? root.$t("Client ID") : root.$t("Account ID"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: authModel.traffic_type === PlatformType.Xmp ? "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Client ID")) : "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Account ID"))
                        }, 
                    ]
                },
                key_id: {
                    label: root.$t("Key ID"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Key ID"))
                        }, 
                    ]
                },
                org_id: {
                    label: root.$t("Org ID"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Org ID"))
                        }, 
                    ]
                },
                org_core_id: {
                    label: root.$t("Org Core ID"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Org Core ID"))
                        }, 
                    ]
                },
                client_secret: {
                    label: authModel.traffic_type === PlatformType.Xmp ? root.$t("Client Secret") : root.$t("Campaign Management API key"),
                    component: "input",
                    field: {
                        placeholder: root.$t("playTurbo.whole.common.form.inputTips")
                    },
                    rules: [
                        {
                            required: true,
                            message: authModel.traffic_type === PlatformType.Xmp ? "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Client Secret")) : "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("Campaign Management API key"))
                        }, 
                    ]
                },
                report_permission: {
                    label: rangeTips,
                    component: "select",
                    field: {
                        options: isRechargePlans.value ? reportPermissionOptions.slice(0, 2) : reportPermissionOptions
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")),
                            trigger: "change"
                        }, 
                    ]
                },
                is_agree: {
                    component: LinkCheckbox,
                    class: "show_all",
                    field: {
                        link: [
                            {
                                href: "".concat(PTUrl, "/#/auth-agreement"),
                                label: root.$t("playTurbo.authAccount.authDialog.agreement")
                            }, 
                        ],
                        label: root.$t("playTurbo.authAccount.authDialog.secret")
                    },
                    rules: [
                        {
                            required: true,
                            message: "".concat(root.$t("playTurbo.whole.common.form.checkTips")),
                            trigger: "change",
                            validator: function(rule, value, callback) {
                                if (value === true) {
                                    callback();
                                } else {
                                    callback(new Error("privacy is required"));
                                }
                            }
                        }, 
                    ]
                }
            };
        });
        var authSchema = computed(function() {
            return {
                type: "object",
                properties: _objectSpread({
                    traffic_type: {
                        label: root.$t("playTurbo.authAccount.accountDialog.info.channel"),
                        component: "select",
                        field: {
                            placeholder: root.$t("playTurbo.whole.choice"),
                            options: addAuthAuthorizeList.value
                        },
                        rules: [
                            {
                                required: true,
                                message: "".concat(root.$t("playTurbo.whole.common.form.inputTips")).concat(root.$t("playTurbo.authAccount.accountDialog.info.channel"))
                            }, 
                        ]
                    }
                }, authModel.traffic_type ? _.pick(authSchemaObj.value, _toConsumableArray(getAuthItem(authModel.traffic_type)).concat(_toConsumableArray([
                    "report_permission",
                    "is_agree"
                ]))) : {})
            };
        });
        var handleClose = function() {
            emit("update:visible", false);
        };
        var handleChange = function(data) {
            if (data.prop === "is_agree") {
                authModel.is_agree = data.value;
            }
        };
        var handleGetUserInfo = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, info, autoKeys;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            authInfoLoading.value = true;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return getAdAuthInfo();
                        case 4:
                            res = _ctx.sent;
                            if (!(res.data.code !== 0)) {
                                _ctx.next = 7;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 7:
                            info = res.data.data.info;
                            autoKeys = [
                                "email",
                                "api_key",
                                "access_key", 
                            ];
                            autoKeys.forEach(function(key) {
                                if (info[key]) {
                                    authModel[key] = info[key];
                                }
                            });
                            authInfoLoading.value = false;
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            authInfoLoading.value = false;
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function handleGetUserInfo() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleCancel = function() {};
        var handleSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, result, data, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate();
                        case 3:
                            result = _ctx.sent;
                            if (result) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            _ctx.prev = 6;
                            loading.value = true;
                            data = getChannelSubmitQuery(authModel);
                            // unity的api_key前端不需要填，后端接口目前为必传，给一个默认值
                            if (data.traffic_type === 5) {
                                data.api_key = "123456";
                            }
                            _ctx.next = 12;
                            return submitAdAccountAuth(data);
                        case 12:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                root.$message.success(String(root.$t("playTurbo.authAccount.auth.success.message")));
                                emit("update:visible", false);
                                emit("reload", false);
                            }
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](6);
                            console.log(_ctx.t0);
                        case 19:
                            loading.value = false;
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        6,
                        16
                    ]
                ]);
            }));
            return function handleSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        var resetForm = function() {
            var _$ref;
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
        };
        var guideLink = computed(function() {
            var url = {
                en: getRouteHelperUrlByDomain("com", "other-tutorials/documentation-for-project-deployment/authorization-of-advertising-accounts-and-apply-materials-to-advertising-platforms"),
                cn: getRouteHelperUrlByDomain("cn", "qi-ta-jiao-cheng/zuo-pin-tou-fang-xiang-guan-wen-dang/guang-gao-zhang-hu-shou-quan-yu-su-cai-tui-song")
            };
            return isCNSuffix() ? url["cn"] : url["en"];
        });
        var handleGuide = function() {
            window.open(guideLink.value);
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                nextTick(function() {
                    resetForm();
                });
            }
        });
        watch(function() {
            return authModel.traffic_type;
        }, function(val) {
            if (val) {
                for(var key in authDefault){
                    if (key !== "traffic_type") {
                        authModel[key] = authDefault[key];
                    }
                }
                authModel.report_permission = isRechargePlans.value ? 2 : 1;
                if ([
                    PlatformType.Xmp
                ].includes(val)) {
                    authModel.type = AdAuthType.Platform;
                    authModel.platform_name = String(val);
                } else {
                    authModel.type = AdAuthType.Channel;
                    authModel.traffic_type = val;
                    delete authModel.platform_name;
                }
                console.log(authModel, "authModel");
            }
        });
        return {
            handleGetUserInfo: handleGetUserInfo,
            handleGuide: handleGuide,
            dialogVisible: dialogVisible,
            authInfoLoading: authInfoLoading,
            handleClose: handleClose,
            authSchemaObj: authSchemaObj,
            handleChange: handleChange,
            handleCancel: handleCancel,
            handleSubmit: handleSubmit,
            authSchema: authSchema,
            authModel: authModel,
            loading: loading,
            formRef: formRef
        };
    }
});
